/*
  MM winkelwagen (vervangt Upcart).
  - Opent na elke "in winkelwagen" (productformulier, quick-add, sticky add-to-cart apps, enz.)
  - Opent bij klik op het winkelwagen-icoon in de header
  - Aantal +/-, typen en verwijderen via /cart/change.js met Section Rendering
  - Werkt samen met Dawn's product-form.js (renderContents / getSectionsToRender)
*/
(function () {
  if (customElements.get('cart-drawer')) return;

  const SECTIONS = ['cart-drawer', 'cart-icon-bubble'];
  const ROOT = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

  function parseSection(html, selector) {
    const doc = new DOMParser().parseFromString(html, 'text/html');
    return selector ? doc.querySelector(selector) : doc.querySelector('.shopify-section') || doc.body;
  }

  class MmCartDrawer extends HTMLElement {
    constructor() {
      super();
      this._refreshTimer = null;
      this._busy = false;

      this.addEventListener('keyup', (evt) => {
        if (evt.code === 'Escape') this.close();
      });
      this.addEventListener('click', this.onClick.bind(this));
      this.addEventListener('change', this.onChange.bind(this));
      this.addEventListener('keydown', (evt) => {
        if (evt.target.matches('[data-mmc-input]') && evt.key === 'Enter') {
          evt.preventDefault();
          evt.target.blur();
        }
      });

      this.bindHeaderIcon();
      this.interceptAddToCart();
      window.mmCart = this;
    }

    /* ---------- open / dicht ---------- */
    bindHeaderIcon() {
      document.addEventListener('click', (event) => {
        const link = event.target.closest('#cart-icon-bubble, [data-mmc-open]');
        if (!link) return;
        if (event.metaKey || event.ctrlKey || event.shiftKey) return;
        event.preventDefault();
        this.open(link);
      });
      const cartLink = document.querySelector('#cart-icon-bubble');
      if (cartLink) {
        cartLink.setAttribute('role', 'button');
        cartLink.setAttribute('aria-haspopup', 'dialog');
      }
    }

    open(triggeredBy) {
      if (triggeredBy) this.setActiveElement(triggeredBy);
      this.setAttribute('aria-hidden', 'false');
      document.body.classList.add('mmc-open');
      requestAnimationFrame(() => {
        this.classList.add('active');
        const panel = this.querySelector('#CartDrawer');
        if (panel) setTimeout(() => panel.focus({ preventScroll: true }), 300);
      });
    }

    close() {
      this.classList.remove('active');
      this.setAttribute('aria-hidden', 'true');
      document.body.classList.remove('mmc-open');
      if (this.activeElement && typeof this.activeElement.focus === 'function') {
        try { this.activeElement.focus({ preventScroll: true }); } catch (e) {}
      }
    }

    setActiveElement(element) {
      this.activeElement = element;
    }

    /* ---------- Dawn-compatibiliteit (product-form.js) ---------- */
    getSectionsToRender() {
      return [
        { id: 'cart-drawer', selector: '#CartDrawer' },
        { id: 'cart-icon-bubble' },
      ];
    }

    renderContents(parsedState) {
      clearTimeout(this._refreshTimer);
      if (parsedState && parsedState.sections) {
        this.applySections(parsedState.sections);
        this.open();
      } else {
        this.refresh(true);
      }
    }

    getSectionInnerHTML(html, selector = '.shopify-section') {
      const el = parseSection(html, selector);
      return el ? el.innerHTML : '';
    }

    applySections(sections) {
      if (!sections) return;
      if (sections['cart-drawer']) {
        const fresh = parseSection(sections['cart-drawer'], '#CartDrawer');
        const panel = this.querySelector('#CartDrawer');
        if (fresh && panel) panel.innerHTML = fresh.innerHTML;
        const wrapper = parseSection(sections['cart-drawer'], 'cart-drawer');
        if (wrapper) this.classList.toggle('is-empty', wrapper.classList.contains('is-empty'));
      }
      if (sections['cart-icon-bubble']) {
        const bubble = document.getElementById('cart-icon-bubble');
        const fresh = parseSection(sections['cart-icon-bubble']);
        if (bubble && fresh) bubble.innerHTML = fresh.innerHTML;
      }
    }

    refresh(openAfter) {
      const url = `${window.location.pathname}?sections=${SECTIONS.join(',')}`;
      return fetch(url, { credentials: 'same-origin' })
        .then((r) => r.json())
        .then((sections) => {
          this.applySections(sections);
          if (openAfter) this.open();
        })
        .catch((e) => console.error('[mm-cart]', e));
    }

    scheduleRefreshAndOpen() {
      clearTimeout(this._refreshTimer);
      this._refreshTimer = setTimeout(() => this.refresh(true), 350);
    }

    /* ---------- regels wijzigen ---------- */
    onClick(event) {
      if (event.target.closest('[data-mmc-close]')) {
        event.preventDefault();
        this.close();
        return;
      }
      const item = event.target.closest('.mmc-item');
      if (!item) return;
      const qty = parseInt(item.dataset.qty, 10) || 0;

      if (event.target.closest('[data-mmc-remove]')) {
        event.preventDefault();
        this.changeLine(item, 0);
      } else if (event.target.closest('[data-mmc-minus]')) {
        event.preventDefault();
        this.changeLine(item, Math.max(qty - 1, 0));
      } else if (event.target.closest('[data-mmc-plus]')) {
        event.preventDefault();
        this.changeLine(item, qty + 1);
      }
    }

    onChange(event) {
      const input = event.target.closest('[data-mmc-input]');
      if (!input) return;
      const item = input.closest('.mmc-item');
      let value = parseInt(input.value, 10);
      if (isNaN(value) || value < 0) value = 0;
      if (value === (parseInt(item.dataset.qty, 10) || 0)) return;
      this.changeLine(item, value);
    }

    changeLine(item, quantity) {
      if (this._busy) return;
      this._busy = true;
      item.classList.add('is-loading');
      const errorEl = item.querySelector('.mmc-item__error');
      if (errorEl) errorEl.hidden = true;

      fetch(`${ROOT}cart/change.js`, {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({
          id: item.dataset.key,
          quantity: quantity,
          sections: SECTIONS,
          sections_url: window.location.pathname,
        }),
      })
        .then((r) => r.json().then((data) => ({ ok: r.ok, data })))
        .then(({ ok, data }) => {
          if (!ok || data.status) {
            item.classList.remove('is-loading');
            if (errorEl) {
              errorEl.textContent = data.description || data.message || (window.cartStrings && window.cartStrings.error) || 'Er ging iets mis.';
              errorEl.hidden = false;
            }
            const input = item.querySelector('[data-mmc-input]');
            if (input) input.value = item.dataset.qty;
            return;
          }
          this.applySections(data.sections);
          if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
            publish(PUB_SUB_EVENTS.cartUpdate, { source: 'cart-drawer', cartData: data });
          }
          document.dispatchEvent(new CustomEvent('mm:cart:updated', { detail: data }));
        })
        .catch((e) => {
          console.error('[mm-cart]', e);
          item.classList.remove('is-loading');
        })
        .finally(() => {
          this._busy = false;
        });
    }

    /* ---------- alle add-to-carts opvangen (zoals Upcart) ---------- */
    interceptAddToCart() {
      if (window.__mmCartIntercepted) return;
      window.__mmCartIntercepted = true;
      const self = this;
      const isAdd = (url) => /\/cart\/add(\.js|\.json)?(\?|$)/.test(String(url || ''));

      const origFetch = window.fetch;
      window.fetch = function (input, init) {
        const url = typeof input === 'string' ? input : input && input.url;
        const p = origFetch.apply(this, arguments);
        if (isAdd(url)) {
          p.then((res) => {
            if (res && res.ok) self.scheduleRefreshAndOpen();
          }).catch(() => {});
        }
        return p;
      };

      const origOpen = XMLHttpRequest.prototype.open;
      const origSend = XMLHttpRequest.prototype.send;
      XMLHttpRequest.prototype.open = function (method, url) {
        this.__mmcUrl = url;
        return origOpen.apply(this, arguments);
      };
      XMLHttpRequest.prototype.send = function () {
        if (isAdd(this.__mmcUrl)) {
          this.addEventListener('load', () => {
            if (this.status >= 200 && this.status < 300) self.scheduleRefreshAndOpen();
          });
        }
        return origSend.apply(this, arguments);
      };

      // Gewone (niet-AJAX) formulieren naar /cart/add: via AJAX versturen en de wagen openen
      document.addEventListener('submit', (event) => {
        const form = event.target;
        if (!(form instanceof HTMLFormElement)) return;
        if (!isAdd(form.getAttribute('action'))) return;
        if (event.defaultPrevented) return; // product-form.js handelt het zelf af
        if (form.closest('product-form')) return;
        event.preventDefault();
        origFetch(`${ROOT}cart/add.js`, {
          method: 'POST',
          credentials: 'same-origin',
          headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
          body: new FormData(form),
        })
          .then((r) => r.json().then((data) => ({ ok: r.ok, data })))
          .then(({ ok, data }) => {
            if (ok && !data.status) self.refresh(true);
            else form.submit();
          })
          .catch(() => form.submit());
      });
    }
  }

  customElements.define('cart-drawer', MmCartDrawer);
})();
